var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('exam-form',{attrs:{"exam_prop":_vm.exam,"edit_mood":_vm.editMood},on:{"formSubmitted":_vm.formsubmittion}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }